/* PALADIN swirling letters (the "spiral") — PAUSED.
   Switched off on every page until we decide which animation goes on each page (13 Oct).
   Any page that still calls PaladinFalling.anchor() or .page() now does nothing.
   The full previous version of this file can be restored from the build notes / earlier theme history if needed. */
(function () {
  if (window.PaladinFalling) return;
  window.PaladinFalling = {
    paused: true,
    anchor: function () {},
    landing: function () {},
    page: function (canvas) {
      if (canvas && canvas.parentNode) canvas.parentNode.removeChild(canvas);
    }
  };
})();
